<div class="request-wrap" layout layout-space-between padding-lr-small padding-tb-small>
  <div layout-horizontal margin-top-small-xxx margin-right-small>
    <rt-icon
      name="timer-sand"
      colorToken="colorIconPrimaryDefault"
      size="medium"
      margin-right-small
    ></rt-icon>
    <div class="text-wrap">
      <span
        [innerHTML]="
          request.triggered
            ? ('app.automated_actions.request_item_v2' | translate)
            : ('app.interview.request_item_v2'
              | translate
                : {
                    requestedBy: !!request.requestedBy?.length
                      ? request.requestedBy
                      : ('app.common.deleted_user' | translate),
                  })
        "
      ></span>
      <rt-date [time]="request.createdAt" [colorDarkest]="true" margin-right-medium> </rt-date>
    </div>
  </div>
  <rt-button
    variant="outline-informative"
    size="small"
    (click)="startEvaluationClick.emit(request)"
  >
    {{ 'app.interview.request_links.start_evaluation' | translate }}
  </rt-button>
</div>
